<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content">
            <div class="box">
                <article class="media">
                    <div class="media-content">
                        <div class="content">
                            <h3 class="title has-text-danger has-text-centered">DELETE THIS PROFORMA?</h3>
                            <div class="has-text-centered">
                                <a class="button" @click="closeModal">close</a>
                                <a class="button is-danger" @click="deleteThisProforma">DELETE</a>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
</template>

<script>
    export default {
        props: ['car', 'proforma_invoice'],
        computed: {
            isActive() {
                return this.$store.getters.getProformaDeleteModalStatus
            }
        },
        methods: {
            closeModal () {
                this.$store.dispatch('setProformaDeleteModalStatus', false)
            },
            deleteThisProforma () {
                this.$store.dispatch('deleteInvoiceById', this.proforma_invoice.id)
                this.$store.dispatch('changeProformaInvoiceModalStatus', { status: false, carId: this.car.id })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/DeleteProformaModal.vue